import React, { Component } from 'react'
import PropTypes from 'prop-types'
import OnboardingListItem from './OnboardingListItem'

export default class InvitedPersonsWrapper extends Component {
  static propTypes = {
    data: PropTypes.any.isRequired,
  }

  render() {
    const { data } = this.props
    return (
      <div>
        <div>
          <div className="card invite-list"
               style={{ boxShadow: (data.length > 3 ? '0px -10px 10px -10px #000 inset' : 'none')}}
          >
            {data.length ?
              data.map(item => (
              <OnboardingListItem key={item._id} id={item._id} content={item.fullName} />
            ))
            :
              <div className="text-center">We'll list your kids here as they join</div>
            }
          </div>

        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/authenticated/ParentDashboard/components/SignedUpPersonsWrapper.js